// extracted by mini-css-extract-plugin
export default {"root":"AXGWbZFx","root__align_incoming":"lb2LkqOm","root__align_outgoing":"Anx5mjdr","root__platform_vkcom":"tfotEr__","actionsWrapper":"w3so4Xqo"};